var map = {
	"./75_costume.mp3": "5659",
	"./76_dino.mp3": "ded1",
	"./77_clown.mp3": "2fe1",
	"./78_pirate.mp3": "9306",
	"./M_Brilliant.mp3": "18f1",
	"./M_Excellent.mp3": "daf3",
	"./M_Fantastic.mp3": "dd7e",
	"./M_Great.mp3": "97a7",
	"./M_Perfect.mp3": "8a46",
	"./M_Think again.mp3": "e445",
	"./M_Try again.mp3": "4975",
	"./M_Very good.mp3": "a4f2",
	"./M_Well done.mp3": "941c0",
	"./M_Work harder.mp3": "251c",
	"./click.mp3": "b09c",
	"./false.mp3": "426b",
	"./true.mp3": "d6be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ef8";